module.exports = __webpack_public_path__ + "static/media/limix_without.3ba5759e.dae";